<app-header [cadastroGeral]="cadastroGeral" [contatoGeral]="contatoGeral"></app-header>

<main>
  <router-outlet></router-outlet>
</main>

<app-footer [cadastroGeral]="cadastroGeral" [contatoGeral]="contatoGeral"></app-footer>
<app-loading></app-loading>
<app-alert></app-alert>